module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/legend.71fa10b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/legend.jpg
// module id = taSx
// module chunks = 0